/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout_In_ProgressInputs */

const en_logout_in_progress = /** @type {(inputs: Logout_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing out...`)
};

const fr_logout_in_progress = /** @type {(inputs: Logout_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion...`)
};

const ms_sg2_logout_in_progress = /** @type {(inputs: Logout_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang log keluar...`)
};

/**
* | output |
* | --- |
* | "Signing out..." |
*
* @param {Logout_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const logout_in_progress = /** @type {((inputs?: Logout_In_ProgressInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout_In_ProgressInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logout_in_progress(inputs)
	if (locale === "fr") return fr_logout_in_progress(inputs)
	return ms_sg2_logout_in_progress(inputs)
});